function requiredEnvVar(name: string): string {
  const value = process.env[name];
  if (!value) {
    throw new Error(`Required environment variable "${name}" not found`);
  }
  return value;
}

export const REACT_APP_FIREBASE_API_KEY = requiredEnvVar(
  "REACT_APP_FIREBASE_API_KEY"
);
export const REACT_APP_FIREBASE_AUTH_DOMAIN = requiredEnvVar(
  "REACT_APP_FIREBASE_AUTH_DOMAIN"
);
export const REACT_APP_FIREBASE_DATABASE_URL = requiredEnvVar(
  "REACT_APP_FIREBASE_DATABASE_URL"
);
export const REACT_APP_FIREBASE_PROJECT_ID = requiredEnvVar(
  "REACT_APP_FIREBASE_PROJECT_ID"
);
export const REACT_APP_FIREBASE_STORAGE_BUCKET = requiredEnvVar(
  "REACT_APP_FIREBASE_STORAGE_BUCKET"
);
export const REACT_APP_FIREBASE_MESSAGE_SENDER_ID = requiredEnvVar(
  "REACT_APP_FIREBASE_MESSAGE_SENDER_ID"
);
export const REACT_APP_FIREBASE_APP_ID = requiredEnvVar(
  "REACT_APP_FIREBASE_APP_ID"
);
export const REACT_APP_FIREBASE_MEASUREMENT_ID = requiredEnvVar(
  "REACT_APP_FIREBASE_MEASUREMENT_ID"
);

export const REACT_APP_HAS_LOGGED_IN_COOKIE_NAME = "growme_has_logged_in";
export const GROWME_ANONYMOUS_ID_COOKIE_NAME = "growme_anonymous_id";
export const GROW_UNVERIFIED_READER_ID_COOKIE_NAME =
  "grow_unverified_reader_id";
export const REACT_APP_BACKEND_BASE_URL = requiredEnvVar(
  "REACT_APP_BACKEND_BASE_URL"
);
export const REACT_APP_LOGIN_REGISTER_BASE_URL = requiredEnvVar(
  "REACT_APP_LOGIN_REGISTER_BASE_URL"
);

export const TOS_URL = "https://www.grow.me/tos.html";
export const GROW_ME_URL = "https://www.grow.me/";
export const PRIVACY_POLICY_URL = "https://www.mediavine.com/privacy-policy";
export const CONTACT_US_EMAIL = "grow.me@mediavine.com";
export const MEDIAVINE_FACEBOOK_URL =
  "https://www.facebook.com/mediavinepublishernetwork";
export const MEDIAVINE_INSTAGRAM_URL = "https://www.instagram.com/mediavine";
export const MEDIAVINE_TWITTER_URL = "https://twitter.com/mediavine";

export const SNOWPLOW_APP_ID = "growme";
export const SNOWPLOW_TRACKER_NAMESPACE = "grow-me-app-prod";
export const SNOWPLOW_COLLECTOR_URL =
  "https://snowplow.mediavine.com/com.snowplowanalytics.snowplow/tp2";
export const REACT_APP_PACKAGE_VERSION = requiredEnvVar(
  "REACT_APP_PACKAGE_VERSION"
);
